{
  "version": 1,
  "asset_id": "88f9feb9-9765-4a21-9323-f286fe68a299",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/88f9feb9-9765-4a21-9323-f286fe68a299/beylikduzu-hizli-elektrikci-7-24-dukkan-3.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/88f9feb9-9765-4a21-9323-f286fe68a299/beylikduzu-hizli-elektrikci-7-24-dukkan-3.jpg",
  "original_filename": "beylikduzu-hizli-elektrikci-7-24-dukkan-3.jpg",
  "size": 551056,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:13:36Z"
}
